import React, { useCallback, useState } from "react";
import axios from "axios";
import { useDelete } from "../customHooks/useDelete/useDelete";
import useEdit from "../customHooks/useEdit/useEdit";
import ConfirmationPrompt from "../components/ConfirmationPrompt";
import { toast } from "react-toastify";
import { ActionCells } from "../components/ActionCells";
import PermissionPrompt from "../components/PermissionPrompt";
import { usePermissions } from "../utils/Customhooks/permissionHook/usePermissionHook";

import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../redux/store";
import { setRerender } from "../generatedSlice/productSlice";
import { updateStatus } from "../generatedRequest/product";
import { useStatus } from "../customHooks/useStatus/useStatus";
import CarouselDemo from "../app/pages/Carousel";
import useClone from "../customHooks/useClone/useClone";
import ClonePrompt from "../components/ClonePrompt";
import CloneRegionModel from "../components/CloneRegionModel";
import { addMaster } from "../generatedRequest/master";
// import  useMaster from "../customHooks/useMaster/useMaster";
import MasterFormModal from "../generatedFormModal/MasterFormModal";

import { singleApprove , deleteIcecatProduct} from '../generatedRequest/icecatdata'

const moduleName = "icecat";

const IcecatTableAction = ({ Icecatproduct }: any) => {
  const { rerender1 } = useSelector((state: RootState) => state.product);
  const [showPreviewPrompt, setPreviewPrompt] = useState(false);
  const { doEdit } = useEdit(moduleName);
  // const { addMasterModel} = useMaster(moduleName)
  const dispatch = useDispatch();
  const [showPermissionPrompt, setShowPermissionPrompt] =
    useState<boolean>(false);
  const [newPayloads, setNewPayloads] = useState([]);
  const [selectedRegion, setSelectedRegion] = useState<any[]>([]);
  const [showCloneStatusModel, setShowCloneStatusModel] = useState(false);
  const [statusData, setStatusData] = useState([]);
 

  
  // let payload = {
  //   productName: product.productName,
  //   attributes:[],
  //   productImages: product.productImages.map((image:any)=> image),
  //   description: product.description,
  //   subcategory: product.subcategory._id,
  //   regions:selectedRegion.map((region:any) => region.id || region._id),
  //   category: product.category._id,
  //   brand:product.brand,
  //   model:product.model,
  //   modelNumber:product.modelNumber,
  //   sku:product.sku
  // };

  // Callback function to receive data from the child component


  const handleAfterDelete = useCallback(
    (flag: boolean, response: any) => {
      if (flag) {
        toast.success("record deleted");
        dispatch(setRerender(!rerender1));
        // do whatever you want with response
      } else {
        toast.error("error");
      }
    },
    [rerender1, dispatch]
  );
  const { canDo, currentActivity } = usePermissions();

  const handleAfterStatus = useCallback(
    (status: boolean, res: any) => {
      if (status) {
        toast.success("status updated successfully");
        dispatch(setRerender(!rerender1));
      } else {
        //TODO: make error when go live
        toast.error("something went wrong");
      }
    },
    [rerender1, dispatch]
  );

  const handleAfterClone = useCallback(
    (data: any) => {
      // if (status) {
      //   toast.success("Clone created successfully");
      dispatch(setRerender(!rerender1));
      setShowCloneStatusModel(true);
      setStatusData(data);
      // } else {
      //   //TODO: make error when go live
      //   toast.error(res?.data?.message);
      // }
    },
    [rerender1, dispatch]
  );

  const { onDelete, deleteRecord, showPrompt, onCancel, loading } = useDelete(
    deleteIcecatProduct,
    true,
    handleAfterDelete
  );

  const {
    onStatus,
    showStatusPrompt,
    statusloading,
    statusToUpdate,
    onstatusCancel,
    ChangeStatus,
  } = useStatus(updateStatus, true, handleAfterStatus);

  const {
    onClone,
    showClonePrompt,
    setCloneShowPrompt,
    cloneLoading,
    recordToClone,
    onCancelClone,
    cloneRecord,
    newRegion,
  } = useClone(
  
    singleApprove,
  
   
   
  );

  const actions = ["Edit", "Delete"];

  // const handlePreviewPrompt = useCallback(() => {
  //   const fn = () => {
  //     console.log("here")
  //     setPreviewPrompt(!showPreviewPrompt);
  //   };
  //   fn();
  // }, []);

  
  const handlePreviewPrompt = useCallback(() => {
    const fn = () => {
      setPreviewPrompt(!showPreviewPrompt);
    };
    fn();
  }, [showPreviewPrompt]);

  const handleCancel = useCallback(() => {
    const fn = () => {
      setShowPermissionPrompt(false);
    };
    fn();
  }, []);

 

  const onBackHandler = useCallback(() => {
    setShowCloneStatusModel(false);
    setCloneShowPrompt(true);
  }, []);


  

  const handleSelect = useCallback(
    (selectedAction: string) => {
      switch (selectedAction) {
        case "Edit":
          // if (canDo(moduleName, "Edit")) {
          doEdit(Icecatproduct._id);
          // } else {
          //   setShowPermissionPrompt(true);
          // }
          break;
        case "Delete":
          // if (canDo(moduleName, "Delete")) {
          onDelete(Icecatproduct._id);
          // } else {
          //   setShowPermissionPrompt(true);
          // }
          break;
       
      
       
        default:
          break;
      }
    },
    [canDo, doEdit, Icecatproduct, onDelete, onClone]
  );

  return (
    <>
      {showPermissionPrompt && (
        <PermissionPrompt
          title={"Access Denied"}
          image="/media/auth/permission-error-light.svg"
          message={currentActivity ? currentActivity : ""}
          onCancel={handleCancel}
          moduleName={moduleName}
        />
      )}
      {showPrompt && (
        <ConfirmationPrompt
          title={"Delete Record"}
          message={"Are you sure to delete this record?"}
          onConfirm={deleteRecord}
          onCancel={onCancel}
          isloading={loading}
        />
      )}
     

   

    

     
      <ActionCells actions={actions} onSelect={handleSelect} />

    
    </>
  );
};
export default IcecatTableAction;

